import { Calendar, Building2 } from "lucide-react";
import { Button } from "@/shared/components/form/Button";
import useTranslations from "@/shared/lang/useTranslations";

type OrganizationsTableHeaderProps = {
  currentCount: number;
  totalCount: number;
  onNewOrganizationClick?: () => void;
};

export const OrganizationsTableHeader = ({
  currentCount,
  totalCount,
  onNewOrganizationClick,
}: OrganizationsTableHeaderProps) => {
  const { t } = useTranslations("cards");

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center justify-between gap-4 pb-2 w-full">
        <div className="flex items-center gap-3">
          {onNewOrganizationClick && (
            <Button
              variant="primary"
              onClick={onNewOrganizationClick}
              className="whitespace-nowrap h-12 rounded-4xl shrink-0 flex items-center gap-2"
            >
              <Building2 className="h-4 w-4" />
              {t("organizations_header_new_organization")}
            </Button>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <div className="inline-flex items-center gap-2 rounded-full border border-green-500 bg-green-500 px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white shadow-sm dark:border-green-400 dark:bg-green-400 dark:text-white">
            <Calendar className="h-3.5 w-3.5" />
            <span>
              {currentCount}/{totalCount} {t("organizations_header_organizations_created")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
